import { compose } from 'ramda';

import { offerSelector } from './offer';
import { getCoworkingOfferTypeByOffer } from '../../../utils/getCoworkingOfferTypeByOffer';

export const coworkingOfferTypeSelector = compose(getCoworkingOfferTypeByOffer, offerSelector);
